<template>
  <div>
    <commonTable
      ref="commonTable"
      url="admin/money_orders/list"
      reqMethod="GET"
      :column="column"
      :searchColumn="searchColumn"
      :extraParams="extraParams"
      limitKey="per_page"
      @reset="() => {
        extraParams = {
          pay_type: null
        }
      }"
    >
      <template slot="search-back">
        <el-form-item>
          <el-select
            v-model="extraParams.pay_type" placeholder="支付类型">
            <el-option
              v-for="item in payTypeList"
              :key="item"
              :label="item"
              :value="item">
            </el-option>
          </el-select>
        </el-form-item>
      </template>
      <template slot="search" slot-scope="scope">
        <el-form-item>
          <el-button type="success" @click="exportOrderList(scope.searchValue)"
            >导出</el-button
          >
        </el-form-item>
      </template>
    </commonTable>
  </div>
</template>

<script>
import fetch from "@/assets/js/axios.js"
import { urlSplicing } from "@/assets/js/public.js"
import commonTable from '@/component/commonTable.vue'
export default {
  name: 'coinOrder',
  components: {
    commonTable
  },
  data () {
    return {
      orderStatus: [
        {
          value: 0,
          label: '已取消'
        },
        {
          value: 10,
          label: '待付款'
        },
        {
          value: 20,
          label: '已支付，待发货'
        },
        {
          value: 100,
          label: '已完成'
        }
      ],
      extraParams: {
        pay_type: null,
      },
      payTypeList: [],
    }
  },
  computed: {
    column () {
      return [
        {
          label: "订单编号",
          prop: "order_no",
          fixed: true
        },
        {
          label: "用户账号",
          prop: "user.username",
          fixed: true
        },
        {
          label: "商品",
          prop: "subject"
        },
        {
          label: "支付类型",
          prop: "pay_type",
        },
        {
          label: "订单金额",
          prop: "amount",
          formatter: (row, column, cellValue) => {
            return '￥' + cellValue
          }
        },
        {
          label: "订单状态",
          prop: "status",
          formatter: (row, column, cellValue) => {
            const target = this.orderStatus.find(item => item.value === cellValue)
            return target && target.label ? target.label : '-'
          }
        },
        {
          label: "时间",
          prop: "created_at",
        },
      ]
    },
    searchColumn () {
      return [
        {
          label: "订单编号",
          prop: "order_no",
          type: "input",
        },
        {
          label: "账号",
          prop: "username",
          type: "input",
        },
        {
          label: "状态",
          prop: "status",
          type: "select",
          option: this.orderStatus
        },
        {
          label: "提交时间",
          prop: "created_from+created_to",
          type: "date",
          timerange: []
        },
      ]
    }
  },
  mounted () {
    this.getPayTypeList()
  },
  methods: {
    getPayTypeList () {
      fetch({
        url: `/admin/money_orders/pay_type`,
        method: 'GET',
      }).then(res => {
        if (res.data.status && res.data.data) {
          this.payTypeList = res.data.data.filter(item => item)
        } else {
          this.$message.error(res.data.message)
        }
      })
    },
    // 导出
    exportOrderList(searchValue) {
      let params = {
        ...this.searchValue, // 传对应的搜索的值
        export: 1,
        token: sessionStorage.getItem("access_token"),
      };

      urlSplicing(this.$store.state.host + "/admin/money_orders/list", params);
    },
  }
}
</script>

<style lang="less" scoped>
.order-statistics {
  width: 100%;
  height: 60px;
  display: flex;
  align-items: center;
  padding-left: 0;
  color: rgba(0, 0, 0, 0.7);
  margin-bottom: 30px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  padding-left: 10px;
  list-style: none;
  li {
    margin-right: 30px;
  }
}

</style>
